/**
 * Returns true only when `url` resolves to the current page origin. Fails closed (false) on a
 * malformed URL so the replay id is never injected onto a request we can't prove is same-origin.
 */
export const isSameOrigin = (url: string): boolean => {
    try {
        return new URL(url, window.location.href).origin === window.location.origin;
    } catch {
        return false;
    }
};
